import styled from 'styled-components'

export const Container = styled.footer`
  padding: 2rem;
  margin: 0;
  bottom: 0;
  width: 100vw;

  background: ${({ theme }) => `rgb(${theme.background.high})`};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    height: 2rem;
    width: 8.18rem;
  }

  p {
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  .logoDirecao {
    height: 50px;
    width: 190px;
  }
`
